export default __webpack_public_path__ + "static/media/Flexible Discount.7262896e.png";